/** @typedef {'R' | 'A' | 'C' | 'I'} RaciValue */

export const RACI_VALUES = ['R', 'A', 'C', 'I'];

export const RACI_LEGEND_ITEMS = [
    {
        value: 'R',
        title: 'Responsible',
        description: 'Performs the work or completes the activity.',
    },
    {
        value: 'A',
        title: 'Accountable',
        description: 'Ultimately accountable for the outcome or approval.',
    },
    {
        value: 'C',
        title: 'Consulted',
        description: 'Provides input before or during the activity.',
    },
    {
        value: 'I',
        title: 'Informed',
        description: 'Kept informed of progress or outcomes.',
    },
    {
        value: '',
        title: 'Blank',
        description: 'No defined involvement for this activity.',
    },
];

export const ACTIVITY_COLUMN_MIN_WIDTH = 280;
export const STAKEHOLDER_COLUMN_WIDTH = 200;

export const createId = () => {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return `raci-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
};
